<template>
  <div class="MagazineList w-full">
    <div v-html="htmlData"></div>
  </div>
</template>
<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
export default {
  name: 'MagazineDetail',
  data () {
    return {
      htmlData: null
    }
  },
  watch: {
    '$route.params.class': {
      handler (newVal, oldVal) {
        let self = this
        if (newVal && (newVal !== oldVal)) {
          self.getData()
        }
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      let self = this
      axios.get(`/magazines/${self.$route.params.class.toLowerCase()}/intro`)
        .then((response) => {
          self.htmlData = response.data
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss">
.MagazineList {
  .ifreme-outer {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  img {
    width: 100% !important;
    display: block;
    object-fit: contain;
  }
}
</style>
